import { BUSINESS_INFO } from '../data/businessInfo';
import { canonicalPathname } from './canonicalPath';

const WEBSITE_HOSTS = new Set([
  'alltimepaintandplaster.com', 'www.alltimepaintandplaster.com',
  'alltimepainters.com', 'www.alltimepainters.com',
  'alltimepaintandplaster.lovable.app',
]);

/** A page's canonical is its actual path, never a caller-supplied alias or query. */
export function canonicalPageUrl(pathname: string): string {
  return `${BUSINESS_INFO.website}${canonicalPathname(pathname)}`;
}

/** Normalize website references only; the independent shop and third parties stay intact. */
export function normalizeWebsiteUrl(value: string): string {
  if (!/^https?:\/\//i.test(value) && !value.startsWith('/')) return value;
  try {
    const url = new URL(value, BUSINESS_INFO.website);
    if (!WEBSITE_HOSTS.has(url.hostname)) return value;
    return `${canonicalPageUrl(url.pathname)}${url.search}${url.hash}`;
  } catch {
    return value;
  }
}

/** Normalize URL-valued schema fields without changing prose, review text or external identities. */
export function normalizeSchemaWebsiteUrls(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(normalizeSchemaWebsiteUrls);
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, normalizeSchemaWebsiteUrls(item)]));
  }
  return typeof value === 'string' ? normalizeWebsiteUrl(value) : value;
}